var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgGa = function SvgGa(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 640 480"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#ffe700",
    d: "M640 480H0V0h640z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#36a100",
    d: "M640 160H0V0h640z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#006dbc",
    d: "M640 480H0V320h640z"
  }))));
};
export default SvgGa;